import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-side-nav-bets',
  templateUrl: './side-nav-bets.component.html',
  styleUrls: ['./side-nav-bets.component.scss'],
})
export class SideNavBetsComponent implements OnInit {
  title = 'app-side-nav-bets';

  ngOnInit(): void {}
}
